/* tslint:disable */
/* eslint-disable */
export enum AuthLoginTypeEnum {
  Username = 'Username',
  Email = 'Email',
  CustomerNumber = 'CustomerNumber',
  Pin = 'Pin',
  Biometric = 'Biometric'
}
